<template>
  <header class="Header">
    <nav class="Header__navigation">
      <div class="Header__logo">
        <router-link to="/">
          <img class="Header__logo-image" src="/img/logo.png"/>
        </router-link>
      </div>
      <ul ref="list" :class="{'is-active': isMenuShown}" v-click-outside="onClickOutsideMenu" class="Header__list">
        <li
            v-for="(item, index) in routes"
            :key="index"
            v-click-outside="onClickOutside"
            :class="{'has-child': item.hasChild}"
            class="Header__list-link"
            @click="isShowSubmenu"
        >
          <router-link v-if="!item.hasChild && !item.anchor" :to="item.path">
            {{ item.name }}
          </router-link>
          <router-link v-else-if="item.anchor" :to="item.path" v-scroll-to="'#technologies'">
            {{ item.name }}
          </router-link>
          <span v-else-if="item.hasChild" :class="{'has-child': item.hasChild}">
            {{ item.name }}
            <font-awesome-icon :class="{top: isSubmenuShown}" :icon="['fas', 'sort-down']" />
          </span>
          <transition name="slide-fade">
            <ul v-if="item.hasChild" v-show="isSubmenuShown" class="Header__sublist">
              <li v-for="(subitem, index) in item.items" :key="index" @click="toggleMenu" class="Header__sublist-item">
                <router-link :to="subitem.path">
                  {{ subitem.name }}
                </router-link>
              </li>
            </ul>
          </transition>
        </li>
        <li class="Header__list-link--talk-to-us" @click="isShowSubmenu">
          <router-link to="/contact-us">
            <span>Contact us</span>
          </router-link>
        </li>
      </ul>
      <div class="burger" @click="toggleMenu">
        <span :class="{'active': isMenuShown}"></span>
      </div>
    </nav>
    <div class="Header__overlay" :class="{'active': isMenuShown}"></div>
  </header>
</template>
<script>
import { ROUTES } from '@/assets/routes'
import vClickOutside from 'v-click-outside'

export default {
  name: 'Header',
  data: () =>({
    isMenuShown: false,
    isSubmenuShown: false,
    routes: ROUTES
  }),
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {
    toggleMenu () {
      this.isMenuShown = !this.isMenuShown
    },
    isShowSubmenu (e) {
      e.target.classList.contains('has-child') || !!e.target.closest('.has-child') ? (this.isSubmenuShown = !this.isSubmenuShown) : this.isMenuShown = false;
    },
    onClickOutside (e) {
      if (!(e.target.classList.contains('has-child') || !!e.target.closest('.has-child'))) this.isSubmenuShown = false
    },
    onClickOutsideMenu (e) {
      if(!e.target.classList.contains('burger')) this.isMenuShown = false
    }
  }
}
</script>
<style lang="scss">
.Header {
  position: relative;
  background-color: $color;
  width: 100%;
  height: $header-width;
  padding: 5px 0;
  &__navigation {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8%;
    @media screen and (max-width: 1010px) {
      padding: 0 1%;
    }
  }
  &__logo {
    width: 200px;
    &-image {
      width: 95%;
    }
  }
  &__list {
    display: flex;
    height: 100%;
    align-items: center;

    &-link {
      padding: 17px 30px;
      line-height: 30px;
      position: relative;
      color: white;
      a {
        text-decoration: none;
        color: inherit;
      }
      &.has-child {
        &>span {
          svg {
            margin-left: 15px;
            margin-bottom: 3px;
            transition: .3s;
            &.top {
              margin-bottom: 0;
              transform: rotate(180deg);
            }
          }
          &:hover {
            cursor: pointer;
          }
        }
        @media screen and (max-width: 775px) {
          font-size: 18px;
        }
      }
      &:after {
        background-color: #ffffff;
        display: block;
        content: "";
        height: 2px;
        width: 0;
        -webkit-transition: width .3s ease-in-out;
        -moz--transition: width .3s ease-in-out;
        transition: width .3s ease-in-out;
      }
      &:hover:after,
      &:focus:after {
        width: 57%;
      }
      &--talk-to-us {
        box-sizing: border-box;
        margin-left: 40px;
        text-transform: uppercase;
        a {
          font-weight: 600;
          color: #ffffff;
          padding: 13px 56px;
          border: 2px solid #FCE0DA;
          border-radius: 12px;
          transition: all .3s ease 0ms;
          &:hover {
            background-color: #FCE0DA;
            color: #151147;
          }
        }
      }
      @media screen and (max-width: 1010px) {
        padding: 17px 15px;
      }
      @media screen and (max-width: 775px) {
        color: $color;
        padding: 5px 30px;
        a, span {
          font-size: 20px;
          line-height: 25px;
        }
        &--talk-to-us {
          margin-top: 40px;
          width: 90%;
          margin-left: 20px;
          a {
            border: 2px solid $color;
            color: $color;
            padding: 13px 75px;
            &:hover {
              color: #ffffff;
              background-color: #151147;
            }
          }
        }
      }
    }
    @media screen and (max-width: 775px){
      position: fixed;
      padding: 25px 10px;
      background: #FFFFFF;
      width: 108%;
      height: 100vh;
      top: 80px;
      right: -108%;
      flex-direction: column;
      align-items: flex-start;
      transition: 300ms ease all;
      &.is-active {
        z-index: 999;
        right: -38%;
      }
    }
  }

  &__sublist {
    position: absolute;
    background-color: #ffffff;
    padding: 7px;
    width: 230px;
    top: 55px;
    left: 26px;
    z-index: 2;
    border: 1px solid #F2F2F2;
    box-sizing: border-box;
    box-shadow: 0 15px 30px -10px rgba(21, 17, 71, 0.04);
    border-radius: 8px;
    &-item {
      line-height: 40px;
      border-radius: 4px;
      color: black;
      a {
        color: inherit;
        line-height: 45px;
        display: block;
        padding-left: 10px;
        &:hover {
          color: white;
        }
      }
      &:hover {
        background: $color;
        color: white;
      }
    }
    @media screen and (max-width: 775px){
      position: static;
      border: none;
      box-shadow: none;
      padding-bottom: 0;
      width: 100%;
      &-item {
        &:hover {
          color: $color;
          background: #FFFFFF;
        }
      }
    }
  }
  //----------------------------------------burger-menu-------------------------------------------------
  .burger{
    display: none;
    position: absolute;
    right: 30px;
    top: 16px;
    width: 40px;
    height: 30px;
    cursor: pointer;
    z-index: 99;
    span, span:before, span:after {
      width: 100%;
      position: absolute;
      height: 3px;
      background: #ffffff;
      display: block;
      transition: .3s;
      border-radius: 5px;
    }
    span {
      top: 20px;
      &:before {
        content: "";
        top: -15px;
        transition: top 300ms 300ms, transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
      }
      &:after {
        content: "";
        bottom: -15px;
        transition: bottom 300ms 300ms, transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
      }
      &.active {
        background: rgba(255, 255, 255, 0);
        &:before {
          content: "";
          top: 0px;
          transform: rotate(45deg);
          transition: top 300ms, transform 300ms 300ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }
        &:after {
          content: "";
          bottom: 0;
          transform: rotate(-45deg);
          transition: bottom 300ms, transform 300ms 300ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }
      }
    }
    @media screen and (max-width: 775px) {
      display: block;
    }
  }
  &__overlay {
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: 9;
    display: none;
    opacity: 0;
    transition: 3s ease-in-out;
    @media screen and (max-width: 775px) {
      &.active {
        display: block;
        background: $color;
        opacity: .4;
      }
    }
  }
  @media screen and (max-width: 775px) {
    position: fixed;
    z-index: 99;
  }
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
